module.exports = __webpack_public_path__ + "static/media/invitation.68fabfd6.svg";